module.exports = __webpack_public_path__ + "img/snow_removing_solutions.7c4119fe.jpg";